import { render, staticRenderFns } from "./logo-secondary.vue?vue&type=template&id=6cbfe1b3&scoped=true&"
import script from "./logo-secondary.vue?vue&type=script&lang=js&"
export * from "./logo-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbfe1b3",
  null
  
)

export default component.exports